module.exports = __webpack_public_path__ + "static/media/package-list.658a7eef.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Tutorial/images/package-list.svg
 ** module id = 883
 ** module chunks = 0
 **/